import { RefreshResponse } from "../resources/types/authTypes";

// Utility to get and set user handle from localStorage
export function getUserHandle(): RefreshResponse | null {
  const rawHandle = localStorage.getItem("handle");
  return rawHandle ? (JSON.parse(rawHandle) as RefreshResponse) : null;
}

export function setUserHandle(data: RefreshResponse): void {
  localStorage.setItem("handle", JSON.stringify(data));
}

export function removeUserHandle(): void {
  localStorage.removeItem("handle");
}
